import { url } from 'utils/urls';

const deleteCookie = name => {
    document.cookie = name +`=; Path=/;${url.baseurl === 'localhost' ? '' : ` Domain=.${url.baseurl};`} Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

export const clearCookies = cookies => {
    for (let cookie of cookies) {
        deleteCookie(cookie);
    }
};